<template>
  <div
    id="chart-container"
    style="display: flex; justify-content: center;"
  >
    <div
      id="main"
      ref="chartRef"
      style="block-size: 400px; inline-size: 800px;"
    />
  </div>
</template>

<script setup>
import { PieChart } from 'echarts/charts'
import { LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import * as echarts from 'echarts/core'
import { LabelLayout } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import { defineProps, onMounted, ref, watch } from 'vue'

const props = defineProps({
  chartData: {
    type: Array,
    required: true,
    default: () => [],
  },

  // chartTitle: {
  //   type: String,
  //   default: '',
  // },
})

echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  TitleComponent,
  CanvasRenderer,
  LabelLayout,
])

const chartRef = ref(null)
let myChart = null


const formatNumber = num => {
  if (isNaN(num)) return "0"
  
  return num.toLocaleString('en-US') 
}

const breakLabel = label => {
  const maxLength = 20  // Adjust max length per line
  if (label.length > maxLength) {
    const index = label.lastIndexOf(' ', maxLength)
    
    return label.slice(0, index) + '\n' + label.slice(index + 1)
  }
  
  return label
}

const initChart = () => {
  const chartDom = chartRef.value
  if (!chartDom) return

  if (!myChart) {
    myChart = echarts.init(chartDom)
  }

  const total = props.chartData.reduce(
    (sum, item) => sum + (parseFloat(item.value) || 0),
    0,
  )

  const option = {
    title: {
      text: props.chartTitle, 
      left: 'center', 
      top: '5%',
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)',
    },
    legend: {
      orient: 'vertical',
      left: '10%',
      top: 'center',
      type: 'scroll',
      itemHeight: 18,
      formatter: name => breakLabel(name),  // Break long labels
    },
    series: [
      {
        name: props.chartTitle,
        type: 'pie',
        radius: ['30%', '60%'],
        center: ['70%', '50%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'center',
          formatter: `{total|${formatNumber(total)}}`,
          rich: {
            total: {
              fontSize: 20,
              fontWeight: 'bold',
            },
          },
        },
        labelLine: {
          show: false,
        },
    
        data: props.chartData.map(item => ({
          ...item,
          value: parseFloat(item.value) || 0,
        })),
      },
    ],
  }

  myChart.setOption(option)

  window.addEventListener('resize', () => {
    myChart.resize()
  })
}

onMounted(() => {
  initChart()
})

watch(
  () => props.chartData,
  () => {
    initChart()
  },
)
</script>

<style scoped>
#main {
  block-size: 400px;
  inline-size: 100%;
}
</style>
